export default {"src":"/_next/static/media/paypal.9e600be0.svg","height":33,"width":124,"blurWidth":0,"blurHeight":0};